export default __webpack_public_path__ + "static/mopping-0f9a90677fe70e71fb9a8657f33543f5.jpeg";